import "../App.css";
import "./Quiz.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

const Quiz = ({ currentQuestion, currentQuestionIndex, selectedAnswers, isMultipleAnswers, handleCheckboxChange, handleRadioChange, handleSubmit, isAnswerSelected }) => {
    return (
        <div className="question-container">
            <div className="question">
                <span className="question-number">{currentQuestionIndex + 1}.</span> 
                <span className="question-section">
                    {currentQuestion.question}
                    {" "}
                    {
                        isMultipleAnswers && (
                            <span>(Choose {currentQuestion.answer.length})</span>
                        )
                    }
                    {
                        !currentQuestion.questionImage[0]?                             
                            ""
                            :
                            <span><img src={currentQuestion.questionImage[0]} alt={`${currentQuestionIndex} - Question`}/></span>
                    }
                </span>
                
            </div>
            <form className="options">
                {currentQuestion.options.map((option, index) => {
                    const isSelected = (
                        selectedAnswers[currentQuestionIndex] || []
                    ).includes(index);
                    return (
                        <div className="optionsWrapper" key={index}>
                            {isMultipleAnswers ? (
                                <>
                                    <input type="checkbox" id={`option-${index}`} checked={isSelected} onChange={() => handleCheckboxChange(index)} />
                                    <label htmlFor={`option-${index}`}>{option}</label>
                                </>
                            ) : (
                                <>
                                    <input type="radio" name={`question-${currentQuestionIndex}`} id={`option-${index}`} checked={isSelected} onChange={() => handleRadioChange(index)} />
                                    {
                                        !currentQuestion.isOptionImage ?
                                            <label htmlFor={`option-${index}`}>{option}</label>
                                            :
                                            <label htmlFor={`option-${index}`}><img src={option} alt={`${index} - Options`}/></label>
                                    }
                                </>
                            )}
                        </div>
                    );
                })}
            </form>
            <button
                className="submit-button"
                onClick={handleSubmit}
                disabled={!isAnswerSelected}
            >
                <FontAwesomeIcon icon={faCheckCircle} /> Submit
            </button>
        </div>
    );
};

export default Quiz;